module.exports = __webpack_public_path__ + "ae79c93617e5d2295c7b235baef293a1.jpg";